import NextStream from './NextStream.container';

export default NextStream;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/nextStream/index.js